var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`min-width:${_vm.barChartGroupSize.chartData.labels.length * 8}px;max-width:100%;`)},[_c('bar-chart',{attrs:{"id":"pie-chart-size","height":_vm.height,"chart-data":_vm.barChartGroupSize.chartData,"extra-options":_vm.barChartGroupSize.extraOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }